import React, { useEffect, useState } from 'react'
import img from "../../rels_assets/images/blog/b-11.jpg";
import Slider from "react-slick";
import { useDispatch, useSelector } from 'react-redux';
import { fetchPopularProjectsRequest } from '../Landing/actions';
import $, { data } from 'jquery';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ProjectListBlock from '../common/Property/projectListBlock';
import MagicSliderDots from 'react-magic-slider-dots';
import 'react-magic-slider-dots/dist/magic-dots.css';
import request from '../../service/request';

const DiscoverProperties = () => {
    const dispatch = useDispatch();
    const [popularprojects, setProject] = useState([]);
    var settings = {
        dots: true,
        infinite: popularprojects.length > 4,
        slidesToShow: 4,
        slidesPerRow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        arrows: false,
        swipeToSlide: true,
        appendDots: dots => {
            return <MagicSliderDots dots={dots} numDotsToShow={6} dotWidth={30} />;
        },
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 1,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 414,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 1,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 574,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 2,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 2,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 2,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 4,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: popularprojects.length > 4,
                    swipeToSlide: true,
                    pauseOnHover: true,
                    dots: true
                }
            },
        ]
    };


    const projects = useSelector(store => store.landingPageData?.popularProjects?.length > 0 ? store.landingPageData.popularProjects : store.landingPageData.popularProjects)
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        /** setProject.! */
        if (projects && typeof projects.data === 'object' && Object.keys(projects.data).length > 0) {
            setProject(projects.data)
        }
    }, [projects]);

    /** Custom function */
    function loadData() {
        dispatch(fetchPopularProjectsRequest(JSON.stringify([data])))
    }

    return (
        <>
            {/* <!-- START SECTION RECENTLY PROPERTIES --> */}
            {
                popularprojects && popularprojects.length > 0 &&

                <section className="featured portfolio rec-pro disc">
                    <div className="container-fluid">
                        <div className="sec-title discover">
                            <h2><span>Discover </span>Popular Projects</h2>
                            {/* <p>We provide full service at every step.</p> */}
                        </div>
                        {/* <PropertyGridBlock /> */}
                        <div className="portfolio col-xl-12">
                            <div className="slick-lancers">

                                <Slider {...settings}>
                                    {
                                        popularprojects.length > 0 && popularprojects.map((item, index) => {
                                            return (
                                                <React.Fragment key={`popular-projects-${index}`}><ProjectListBlock property={item} currency={projects?.currency} /></React.Fragment>
                                            )
                                        })
                                    }
                                </Slider>

                            </div>
                        </div>
                    </div>
                </section>
            }
            {/* <!-- END SECTION RECENTLY PROPERTIES -->  */}
        </>
    )
}

export default DiscoverProperties;
